import { create, type StateCreator } from 'zustand'
import { devtools } from 'zustand/middleware'

import { zustandPlugin } from '@/modules/shared/openreplay'

type State = {
  ids: string[]
}

type Actions = {
  startLoading: () => () => void
}

type StoreMutators = [['zustand/devtools', never]]

const trackedCreator = zustandPlugin as unknown as <T>(
  creator: StateCreator<T, StoreMutators, []>,
  name?: string,
) => StateCreator<T, StoreMutators, []>

let seq = 0

/**
 * Licznik trwających wywołań STAREJ warstwy serwisowej (`app/services/baseService`).
 * Zastępuje reduxowy slice `service`, żeby `baseService` przestał potrzebować
 * `dispatch`.
 *
 * Świadomie NIE jest to `loadingStore`, mimo że kształt jest ten sam. Tamten licznik
 * czyta 58 plików — tabele, modale, stopki i wykresy całej nowej aplikacji — a stary
 * slice czytały dokładnie trzy kontenery (panel admina, import, kursy walut). Wpięcie
 * legacy w globalny licznik sprawiłoby, że każde stare wywołanie API zapala spinnery
 * w niepowiązanych miejscach nowego UI. Rozdzielenie zachowuje zachowanie 1:1.
 *
 * Gdy te trzy ekrany zostaną przepisane, ten store znika razem z nimi.
 */
export const useLegacyServiceLoadingStore = create<State & Actions>()(
  devtools(
    trackedCreator(
      (set) => ({
        ids: [],
        startLoading: () => {
          const id = `legacy-${++seq}`
          set((s) => ({ ids: [...s.ids, id] }), false, 'start')
          let stopped = false
          return () => {
            // Idempotentnie: stara warstwa potrafi wejść w gałąź błędu po tym, jak
            // sukces już zamknął licznik. Slice bronił się przed ujemną wartością
            // klamrą w reducerze; tutaj po prostu nie odejmujemy dwa razy.
            if (stopped) return
            stopped = true
            set((s) => ({ ids: s.ids.filter((x) => x !== id) }), false, 'stop')
          }
        },
      }),
      'legacy-service-loading',
    ),
    { name: 'EasyTacho', store: 'legacy-service-loading' },
  ),
)

export const selectLegacyServiceLoading = (s: State): boolean => s.ids.length > 0
